import React, { useEffect } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { DataContextProvider } from 'dealer-website-components';
import { resolveUrlsMultiLanguage } from '../utils';
import { settings } from '../../config/index.mjs';

export const Root = ({ element }) => <RootWrapper element={element}></RootWrapper>;

function RootWrapper({ element }) {
  const query = useStaticQuery(graphql`
    query MyQuery {
      cms {
        pagesData {
          id
          typeName
          defaultPath
          matchPath
          category
          paths
        }

        pages {
          url
          type
          slug
        }
        pageTypes {
          name
          path
        }
      }
    }
  `);

  const pages = query.cms.pages;
  const defaultPagePathsByPageTypeName =
    query && query.cms.pageTypes
      ? query.cms.pageTypes.reduce((acc, item) => {
          acc[item.name] = item.path;
          return acc;
        }, {})
      : {};

  const resolveGraphQlEndpoint = () => {
    if (settings.PATH_PREFIX && settings.PATH_PREFIX !== '') {
      return settings.PATH_PREFIX + '/graphql';
    } else {
      return '/graphql';
    }
  };

  const dataContextConfiguration = {
    graphqlEndpoint: resolveGraphQlEndpoint(),
    pagesData: query.cms.pagesData,
    pathPrefix: settings.PATH_PREFIX,
    urls: defaultPagePathsByPageTypeName, // TODO: delete when every client is updated to core 2.7.x
    urlsMultiLanguage: resolveUrlsMultiLanguage(defaultPagePathsByPageTypeName, pages), // TODO: delete when every client is updated to core 2.7.x
    features: {
      subscriptions: settings.SUBSCRIPTIONS,
      account: settings.ACCOUNT
    }
  };

  useEffect(() => {
    console.log('- RootWrapper mount -');
  }, []);

  return <DataContextProvider configuration={dataContextConfiguration}>{element}</DataContextProvider>;
}
